import React from 'react';

export const Veryfied = ({ width = '20', height = '20', color = 'black' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.67517 2.06892C9.84751 1.99234 10.0402 1.97958 10.2193 2.03063L10.3248 2.06892L17.5248 5.26814C17.8079 5.39395 17.9897 5.66985 17.9996 5.97293L17.9951 6.08762L17.5372 10.2092C17.3042 12.3058 16.1645 14.1899 14.4272 15.3701L14.1972 15.52L10.424 17.8784C10.197 18.0203 9.91662 18.038 9.67628 17.9316L9.576 17.8784L5.8028 15.52C4.01406 14.402 2.80955 12.5586 2.49834 10.4814L2.46284 10.2092L2.00492 6.08762C1.9707 5.77966 2.11721 5.48352 2.37391 5.32211L2.4752 5.26814L9.67517 2.06892ZM10 4.11313L4.08963 6.73933L4.45061 9.98834C4.61641 11.4807 5.41826 12.8239 6.64247 13.6784L6.86285 13.824L10 15.7849L13.1372 13.824C14.4103 13.0282 15.2737 11.7237 15.5136 10.2501L15.5494 9.98834L15.9104 6.73933L10 4.11313ZM11.2136 7.38222C11.5549 6.94795 12.1835 6.87251 12.6178 7.21372C13.0186 7.52869 13.1138 8.08857 12.8576 8.51441L12.7863 8.61786L9.7863 12.6178C9.44236 13.0555 8.815 13.1229 8.38771 12.7908L8.29288 12.7071L7.29289 11.7071C6.90237 11.3166 6.90237 10.6834 7.29289 10.2929C7.65338 9.93243 8.22061 9.9047 8.6129 10.2097L8.7071 10.2929L8.91006 10.4959L11.2136 7.38222Z"
        fill={color}
      />
    </svg>
  );
};
